<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- apaym free -->
        <section id="pro" class="bg-scroll wide-60 h_1 content-section pro_part division">
            <div class="container">
                <div class="row d-flex align-items-center">


                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 " >
                        <div class="content-img">
                            <img class="img-fluid disp_img disp_img" src="@/assets/images/services-screen/free-url.webp" alt="content-image" />
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                APAYM Free
                            </h2>
                            
                            <!-- Text -->	
                            <p class="" >
                                Pas de connexion pour faire vos opérations? Pas de problème ! Grâce à APAYM Free, connectez vous à votre application APAYM sans internet avec MTN Côte d'Ivoire et Orange Côte d'Ivoire.

                            </p>                    
                           
                                            
                            <!-- Text -->	
                            <p class="" >
                                Consultez votre solde, vérifiez vos transactions, envoyez de l'argent partout dans le monde sans forfait internet avec MTN Côte d'Ivoire et Orange Côte d'Ivoire. Tapez *766# . Simple, rapide, sécurisé
                            </p>

                                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- apaym free -->

        <!-- transfert argent -->
        <section id="pro" class="bg-scroll wide-60 content-section division grey_bck_section sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Transférer de l'argent en toute simplicité
                            </h2>
                            
                           <!-- Text -->	
                           <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Transfert de carte à carte gratuit ( d’une Carte Visa Prépayée Abidjan.net à une autre )</p>							
                            </div>
                                            
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Transfert vers les comptes bancaires en Afrique, en Europe, en Asie et en Inde</p>							
                            </div>

                             <!-- Text -->	
                           <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Transfert sur les Mobile Money (Orange, MTN, Moov et Wave) dans toute la CEDEAO</p>							
                            </div>

                             <!-- Text -->	
                           <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Transfert d'argent vers des services d’envoie d’argent Express (Express Union et WARI)</p>							
                            </div>

                                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid disp_img " src="@/assets/images/services-screen/Transferer.webp" alt="content-image" />
                        </div>
                    </div>


                    


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- transfert argent -->

        <!-- Ma carte virtuelle -->
         <section id="pro" class="bg-scroll wide-60 h_1 content-section division sct_bck  sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">

                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/virtuelle.webp" alt="content-image" />
                        </div>
                    </div> 
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Ma carte Virtuelle
                            </h2>
                            
                           <!-- Text -->
                           
                            <p>Une application, une carte virtuelle.</p>							
                            <p>Quand vous téléchargez APAYM, vous avez systématiquement une carte prépayée Visa virtuelle : la carte APAYM. Initialement activée avec un plafond de 200 000 F, vous pouvez lever le plafond à 2 millions.</p>    
                            <p>Vous pouvez également commander une deuxième carte virtuelle depuis l’application. les cartes virtuelle présentent tous les avantages d’une carte physique : achat, dépôt, transfert sans les inconvénients du retrait en cash</p>                                       
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- END Ma carte virtuelle -->

         <!-- Demander de l'argent -->
         <section id="pro" class="bg-scroll wide-60 content-section division grey_bck_section  sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">                   
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Demander de l'argent à mes proches
                            </h2>
                            
                           <!-- Text -->
                           
                            <p>Besoin de liquidité en urgence? Envoyez un message à vos proches qui ont installé APAYM accompagné d’un émoticône exclusif.</p>							
                            <p>Demander de l’argent n’a jamais été aussi fun.</p>                                           
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->       
                    
                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Demander.webp" alt="content-image" />
                        </div>
                    </div>

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- END demander de l'argent -->

         <!-- Mes Bénéficiaires -->
         <section id="pro" class="bg-scroll wide-60 content-section division  sct_bck sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Beneficiaires.webp" alt="content-image" />
                        </div>
                    </div>
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Mes Bénéficiaires
                            </h2>
                            
                           <!-- Text -->
                           <p>Dépanner ses proches devient un jeu d’enfant avec APAYM. Rapide, sécurisé, vous pouvez offrir du crédit téléphonique (quelque soit l’opérateur)
                             ou faire un transfert d’argent de nos cartes prépayées à celle de votre destinataire sans frais.</p>                                          
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->                                    

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Mes Bénéficiaires-->

        <!--  Acheter du crédit -->
         <section id="pro" class="bg-scroll wide-60 content-section division grey_bck_section sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Acheter du crédit téléphonique partout dans le monde avec APAYM
                            </h2>
                            
                           <!-- Text -->
                           <p>Besoin d’appeler en urgence et plus de crédit téléphonique? Avec Air time achetez la recharge que vous souhaitez, partout dans le monde.</p>                                          
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->       
                    
                     <!-- CONTENT IMAGE --> 
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Airtime.webp" alt="content-image" />
                        </div>
                    </div>

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Acheter du crédit -->

        <!--  aBourse -->
        <section id="pro" class="bg-scroll wide-60 content-section division  sct_bck sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">
                  
                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/a-bourse.webp" alt="content-image" />
                        </div>
                    </div>

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                aBourse
                            </h2>
                            
                           <!-- Text -->
                           <p>Consultez en temps réel les cours de la BRVM depuis votre mobile</p>                                          
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  aBourse-->

         <!--  Faire un don -->
         <section id="pro" class="bg-scroll wide-60 content-section division grey_bck_section sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Faire un don
                            </h2>
                            
                           <!-- Text -->
                           <p>Une cause vous interpelle et vous voulez la soutenir, faire parler son coeur n’a jamais été aussi simple.</p>
                           <p>Vous pouvez lui faire un don en cliquant sur le logo de l’ong ou de l’association et suivre les indications.</p>                                          
                                          
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Dons.webp" alt="content-image" />
                        </div>
                    </div>

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Faire un don-->

         <!--  Pharmacie -->
         <section id="pro" class="bg-scroll wide-60 content-section division sct_bck sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/pharmacie.webp" alt="content-image" />
                        </div>
                    </div>
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Pharmacies
                            </h2>
                            
                           <!-- Text -->
                           <p>Retrouvez la liste de toutes les pharmacies de garde en Côte d’Ivoire grâce à votre application APAYM</p>
                                         
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Pharmacie -->

        <!--  Cagnotte -->
        <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">                  
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Cagnotte
                            </h2>
                            
                           <!-- Text -->
                           <p>La Cagnotte APAYM pour toutes vos collectes d’argent à plusieurs. Atteignez plus rapidement vos objectifs financiers pour des projets communs grâce à la cagnotte APAYM.</p>
                           <p>Elle permet à vos proches, ami(e)s, parents et vous-même d’épargner ensemble des sommes d’argent pour en faire un montant unique.</p>
                                         
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/cagnote.webp" alt="content-image" />
                        </div>
                    </div>
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Cagnotte -->

        <!--  Etat civil -->
        <section id="pro" class="bg-scroll wide-60 content-section  division sct_bck sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">    
                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/etat-civile.webp" alt="content-image" />
                        </div>
                    </div>              
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Etat Civil
                            </h2>
                            
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Extrait de Naissance</p>							
                            </div>

                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Acte de Mariage</p>							
                            </div>
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Acte de Décès</p>							
                            </div>
                                         
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                     
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Etat civil -->

        <!--  Carte cadeaux -->
        <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">                                     
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Cartes Cadeaux
                            </h2>
                            <!-- Text -->
                            <p>On ne devrait pas attendre 24H pour se faire plaisir avec une carte cadeau numérique. Le temps est précieux, APAYM vous le rends.Cliquez sur la carte cadeau de votre choix dans notre bibliothèque, et recevez le code instantanément.</p>
                            <p>Vos cartes Cadeaux disponibles pour le moment sur APAYM :</p>
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>iTunes France</p>							
                            </div>

                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>iTunes USA</p>							
                            </div>
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Google Play</p>							
                            </div>
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>SportCash Côte d’Ivoire</p>							
                            </div>
                                         
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                     <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/carte-cadeaux.webp" alt="content-image" />
                        </div>
                    </div> 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Carte cadeaux -->

         <!--  Payez chez les commerçants en toute facilité -->
         <section id="pro" class="bg-scroll wide-60 content-section pro_part  division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">   
                    
                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/scanner2.webp" alt="content-image" />
                        </div>
                    </div> 
                  
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Payez comme vous voulez</h2>
                            <!-- Text -->
                            <p>Flashez, c’est payé ! Effectuer ses achats sans sortir votre carte VISA est désormais possible grâce à APAYM.</p>
                            <p>Cliquez sur l'icône “Payer” et scannez le QR code du marchand, votre facture est réglée, et ce quelque soit la banque émettrice du QR Code.</p>
                            
                            
                                         
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                    
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Payez chez les commerçants en toute facilité -->

        <!--  e-Wallet -->
        <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section  division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">   
                    
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                e-Wallet
                            </h2>
                            <!-- Text -->
                            <p>Le e-Wallet est votre portefeuille électronique d’APAYM. Ici, vous pouvez organiser et gérer toutes vos cartes bancaires (les cartes Visa prépayée Abidjan.net,
                                 les cartes Visa rattachées à votre compte bancaire, les cartes virtuelles.)</p>
                            <p>Vous pouvez également y ajouter les comptes Mobile Money, les cartes de fidélité, les pièces d'identités et autres documents dont vous avez besoin.</p>                           
                                                                     
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/transactions-e-wallet.webp" alt="content-image" />
                        </div>
                    </div>                     
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  e-Wallet -->

        <!--  Carte de fidélité -->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">   
                    
                    
                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Carte-fidelite.webp" alt="content-image" />
                        </div>
                    </div>  

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Carte de fidélité
                            </h2>
                            <!-- Text -->
                            <p>Quand on a trop de cartes de fidélité, il faut choisir celles qui seront dans son portefeuille, au risque d’oublier les plus importantes dans ses tiroirs.</p>
                            <p>Que diriez-vous si d’un clic tout pouvait être à votre portée? Avec APAYM regrouper toutes ses cartes de fidélité au même endroit n’a jamais été aussi simple.</p>                           
                            <p>Vous pouvez stocker des copies numériques de vos cartes de fidélité, cartes d'avantages, cartes de membre, cartes cadeaux et de vos offres spéciales 
                                (coupons, promotions et remises, par exemple) pour des milliers de marchands simplement en les scannant sur l’application.</p>                                     
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                                        
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Carte de fidélité -->

         <!--  Payez mes factures en toute simplicité -->
         <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Payez mes factures en toute simplicité
                            </h2>
                            <!-- Text -->
                            <p>Payez vos factures d’eau, d'électricité, internet, l’école des enfants et d’autres factures depuis votre téléphone.</p>
                            <p>Cliquez simplement sur le logo de l’entreprise que vous devez régler et suivez les instructions.</p>                         
                                                             
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  

                        <!-- CONTENT IMAGE -->
                        <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Factures.webp" alt="content-image" />
                        </div>
                    </div>  
                                        
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!--  Payez mes factures en toute simplicité -->

        <!--  Achetez vos tickets d'évènements et de spectacles rapidement et en toute simplicité -->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part  division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Tickets.webp" alt="content-image" />
                        </div>
                    </div> 

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Achetez vos tickets d'évènements et de spectacles rapidement sans vous déplacer
                            </h2>
                            <!-- Text -->
                            <p>Profitez de la vie culturelle d’Abidjan. Achetez vos tickets en un seul clic sans quitter votre salon.</p>
                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->                                                                 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Achetez vos tickets d'évènements et de spectacles rapidement et en toute simplicité -->

        <!--  Compagnons -->
        <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                     

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Compagnon
                            </h2>
                            <!-- Text -->
                            <p>La fonctionnalité compagnon est le complice idéal pour les parents qui veulent garder un oeil sur les finances de leurs enfants par exemple.
                            Elle vous permet de suivre toutes les transactions effectuées avec une carte Abidjan.net enregistrée, autre que la vôtre.</p>
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->  
                    
                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/Compagnons.webp" alt="content-image" />
                        </div>
                    </div>
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Compagnons --> 

        <!--  Rechargements (Ajouter de l’argent instantanément et facilement) -->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/rechargement.webp" alt="content-image" />
                        </div>
                    </div> 

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Rechargements (Ajouter de l’argent instantanément et facilement)
                            </h2>
                            <!-- Text -->
                            <p>Grâce à APAYM, rechargez votre compte ou ajouter de l’argent instantanément sur vos cartes VISA en toute sécurité sans vous déplacer. Vous pourrez rapidement :</p>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Recharger vos comptes par carte bancaire (Visa et MasterCard)</p>							
                            </div>
                                            
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Recharger vos comptes par Mobile Money (Orange, MTN et Moov)</p>							
                            </div>
                            
                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->                                                                 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Rechargements (Ajouter de l’argent instantanément et facilement) --> 

         <!--  Suivre toutes vos transactions -->
         <section id="pro" class="bg-scroll wide-60 content-section  division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Suivre toutes vos transactions
                            </h2>
                            <!-- Text -->
                            <p>Suivez l'activité de votre compte en temps réel. Obtenez vos relevés de compte quand vous le souhaitez.</p>
                            <p>Toutes vos transactions sont enregistrées dans l’application pour une meilleure gestion de votre budget financier.</p>
                            <p>Lorsque vous débitez ou créditez vos cartes, lorsque vous effectuez des achats partout dans le monde, vous avez le relevé de toutes vos transactions.</p>
                            <p>Vous pouvez les retrouver par jour, par semaine, par mois selon des périodes bien définies.</p>                            
                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT --> 
                    
                     <!-- CONTENT IMAGE -->
                     <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/solde-cartes.webp" alt="content-image" />
                        </div>
                    </div> 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Suivre toutes vos transactions --> 

        <!--  Alert SMS -->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/alerte-sms.webp" alt="content-image" />
                        </div>
                    </div> 

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Alerte SMS
                            </h2>
                            <!-- Text -->
                            <p>APAYM vous permet de souscrire aux Alertes SMS Abidjan.net pour suivre l’actualité nationale et internationale, directement sur votre mobile.
                                Vous recevrez à cet effet, <strong>4 alertes quotidiennes</strong> relatives aux moments forts de l’actualité.</p>
                            <p>Tous les abonnés Orange, Moov et MTN en Côte d’Ivoire peuvent souscrire aux alertes</p>
                            <p>Souscription : <strong> FCFA par semaine et 515 FCFA par mois</strong> pour recevoir 4 alertes sms quotidiennes sur les points saillants de l’actualité.</p>
                            <p>Toute première souscription au service alertes abidjan.net, donne droit à 7 jours gratuits d’abonnement. Vous pouvez vous désabonner à tout moment, en composant <strong>*432#</strong></p>                            
                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT --> 
                    
                     
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Alert SMS --> 

         <!--  Voucher-->
         <section id="pro" class="bg-scroll wide-60 content-section grey_bck_section division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                  

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Voucher
                            </h2>
                            <!-- Text -->
                            <p>Le Voucher est un moyen de rechargement pour vos Cartes VISA. Le service APAYM Voucher vous permet d’acheter des coupons de rechargement virtuel que vous pouvez offrir à vos proches et leur faire plaisir.</p>
                            <p>Vous pourrez aussi les dépanner en cas d’urgence.</p>
                                                       
                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT --> 
                    
                     <!-- CONTENT IMAGE -->
                   <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/voucher.webp" alt="content-image" />
                        </div>
                    </div> 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Voucher --> 

        <!--  Privilèges-->
        <section id="pro" class="bg-scroll wide-60 content-section pro_part division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 
                 
                     <!-- CONTENT IMAGE -->
                   <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/privileges.webp" alt="content-image" />
                        </div>
                    </div> 

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                Privilèges
                            </h2>
                            <!-- Text -->
                            <p>Retrouvez la liste de vos avantages et réductions sur tous vos achats chez plus de 50 partenaires lié à vos Cartes Visa Prépayée Abidjan.net grâce à APAYM.</p>                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>
                            <RouterLink to="privileges" class="btn btn-lightgreen s_plus" >Voir privilèges</RouterLink>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT --> 
                    
                    
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Privilèges --> 

        <!--  MonKiosk-->
        <section id="pro" class="bg-scroll wide-60 content-section  division sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center"> 

                                    

                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class="h2-xs " >                                
                                MonKiosk
                            </h2>
                            <!-- Text -->
                            <p>Avec APAYM vous pouvez accéder d’un seul clic à MonKiosk, le kiosque numérique qui réunit les journaux et magazines de la Côte d’Ivoire et de la sous région.</p>
                            <p>Grâce à APAYM, vous pouvez payer en toute sécurité où que vous soyez dans le monde vos titres préférés depuis votre téléphone.</p> 
                            <p>Accédez aux éditions intégrales de vos journaux et magazines. Profitez d’une expérience de lecture enrichie avec une mise en page optimisée pour la lecture sur un téléphone et une tablette.</p> 

                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <button class="btn btn-lightorange" @click="redirectToUrl">Télécharger APAYM</button>                
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT --> 
                    
                      <!-- CONTENT IMAGE -->
                   <div class="col-md-5 disp_img" >
                        <div class="content-img">
                            <img class="img-fluid " src="@/assets/images/services-screen/kiosk.webp" alt="content-image" />
                        </div>
                    </div> 
                     
                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- MonKiosk --> 


        <section id="download-4" class="bg-fixed contact-bck p-top-100 download-section division grey_bck_section">
            <div class="container">
                <div class="row">

                                
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Qu'est ce que vous attendez ?</h2>

                            <!-- Text -->
                            <p class="p-lg">Ne perdez plus de temps à vous soucier de vos paiements en ligne. Téléchargez dès maintenant l'application APAYM et simplifiez votre vie en un instant.
                            </p>

                            <!-- HERO STORE BADGES -->													
                            <div class="stores-badge">

                                 <!-- Google Play -->
                                 <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" class="store">
                                    <img class="appstore-original badge_sect" src="@/assets/images/play_store_badge.webp" width="150" alt="appstore-logo">
                                </a> 

                               <!-- AppStore -->
                                <a href="https://apps.apple.com/app/id1211381693" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-store-bage.webp" width="150" alt="googleplay-logo">
                                </a>                                                                            
                                
                                <!-- App Gallery -->
                                <a href="https://appgallery.huawei.com/app/C104470711" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-gallery-badge.webp" width="150" alt="googleplay-logo">
                                </a>

                            </div>


                        </div>
                    </div>	 
                    <!-- END DOWNLOAD TEXT -->


                    <!-- DOWNLOAD IMAGE -->
                    <div class="col-md-12">	
                        <div class="download-img text-center">
                            <img class="img-fluid disp_img" src="@/assets/images/phones_app.webp" alt="download-image">
                        </div>
                    </div>
                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'apaym_pro',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } ,

    

    setup() {
    const redirectToUrl = () => {
        const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
      if (userAgent.includes('huawei') || userAgent.includes('honor')) {
        window.location.href = 'https://appgallery.huawei.com/app/C104470711';
      } else {
        window.location.href = 'https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan';
      }
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
      window.location.href = 'https://apps.apple.com/app/id1211381693';
    } 
    };

    return {
      redirectToUrl,
    };
  },

    
}

</script>

<style scoped>
.contact-bck {
    background-image: url(@/assets/images/tra-waves-contact.png)!important;
    background-position: bottom center;
}
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}


@media screen and (max-width: 767px) {
    
    .disp_img{
        display: none !important;

        }

    .wide-60{
        padding-top: 50px !important;
    }
    .h_1{
        padding-bottom: 10px !important;
    }
    .badge_sect {
    max-width: 108px !important;
}
 
}
</style>

